import type { ReactNode } from "react";
import { SkeletonLoader } from "@hubertai/hubert-component-library";

interface TextProps {
    size?: "small" | "large" | "";
    weight?: "regular" | "medium" | "semibold" | "light";
    block?: boolean;
    className?: string;
    children?: ReactNode;
    loading?: boolean;
    html?: boolean;
    onClick?: () => void;
}

const Text = ({
    size = "",
    weight = "regular",
    block = false,
    className = "",
    children = "",
    loading = false,
    html = false,
    onClick = () => null,
}: TextProps) => {
    const Tag = block ? "div" : "span";
    const textClass = size ? `body-${size}-${weight}` : `body-${weight}`;
    const skeletonClass = loading ? "skeleton-loading" : "";

    if (!html) {
        return (
            <Tag className={`${textClass} ${className} ${skeletonClass}`.trim()} onClick={onClick}>
                {loading ? <SkeletonLoader count={2} /> : children}
            </Tag>
        );
    }

    return loading ? (
        <Tag className={`${textClass} ${className} ${skeletonClass}`.trim()}>
            {loading ? <SkeletonLoader count={3} /> : children}
        </Tag>
    ) : (
        <Tag
            className={`${textClass} ${className} ${skeletonClass}`.trim()}
            dangerouslySetInnerHTML={{ __html: (children as string) ?? "" }}
        />
    );
};

export default Text;
